import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { Spin, Tabs, message, Button, Space, Row } from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import UserProfile from "../../components/UserProfile/UserProfile";
import AdministrationPermissions from "../../components/AdministrationPermissions/AdministrationPermissions";
import AdministrationBlockPermissions from "../../components/AdministrationBlockPermissions/AdministrationBlockPermissions";
import {
  getAssignPermissionsToUserRoute,
  getBlockPermissionsToUserRoute,
  getEditUserInfoRoute,
  getEditUserInfoStatusRoute,
} from "../../lib/rolesRoutes";
import { ReactComponent as BackIcon } from "../../img/back_icon.svg";
import { hasAccess } from "../../hasAccess";
import {
  MENU_USER_USERMANAGEMENT,
  MENU_USER_USERMANAGEMENT_WRITE,
  USERMANAGEMENT_USER_PERMISSIONS,
} from "../../../../lib/const/permissions";

const { TabPane } = Tabs;

export default function UserParametersContainer(props) {
  const {
    users,
    permissions,
    permissionsLoading,
    getUserById,
    handleDeleteUser,
    requirements,
    requirementsLoading,
  } = props;
  const { userId } = useParams();
  const history = useHistory();
  const { url } = useRouteMatch();
  const [user, setUser] = useState();
  const [userLoaded, setUserLoaded] = useState(false);

  const fetchUserById = () => {
    setUserLoaded(false);
    getUserById(userId).then((res) => {
      setUser(res);
      setUserLoaded(true);
    });
  };

  const handleAssignPermissionsToUser = async (permissionsArr) => {
    try {
      await axios.put(
        getAssignPermissionsToUserRoute(
          user.id,
          permissionsArr,
          user.excludedPermissions.map((item) => item.id)
        )
      );
      message.success("Привилегии отредактированы");
      fetchUserById();
      return true;
    } catch (e) {
      message.error("Ошибка");
      return false;
    }
  };

  const handleBlockPermissionsToUser = async (permissionsArr) => {
    try {
      await axios.put(
        getBlockPermissionsToUserRoute(
          user.id,
          permissionsArr,
          user.includedPermissions.map((item) => item.id)
        )
      );
      message.success("Привилегии отредактированы");
      fetchUserById();
      return true;
    } catch (e) {
      message.error("Ошибка");
      return false;
    }
  };

  const handleEditUserInfo = async (userId, body) => {
    try {
      await axios.patch(getEditUserInfoRoute(userId), body);
      message.success("Данные пользователя изменены");
      fetchUserById();
      return true;
    } catch (e) {
      message.error("Ошибка");
      return false;
    }
  };

  const handleEditUserInfoStatus = async (userId, body) => {
    try {
      await axios.put(getEditUserInfoStatusRoute(userId), body);
      fetchUserById();
      return true;
    } catch (e) {
      message.error("Ошибка");
      return false;
    }
  };

  useEffect(() => {
    fetchUserById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderUserTabs = () => (
    <>
      <Row>
        <Space>
          <Button
            style={{ marginBottom: "13px", borderRight: "1px solid grey" }}
            icon={<BackIcon />}
            type="text"
            htmlType="button"
            onClick={() => {
              history.push(url.split("/").slice(0, -2).join("/"));
            }}
          />
          <h1>Параметры пользователя</h1>
        </Space>
      </Row>
      <Tabs defaultActiveKey="1" type="card">
        {hasAccess(MENU_USER_USERMANAGEMENT, MENU_USER_USERMANAGEMENT_WRITE) && (
          <TabPane tab="Профиль" key="1">
            <UserProfile
              user={user}
              handleDeleteUser={handleDeleteUser}
              handleEditUserInfo={handleEditUserInfo}
              requirements={requirements}
              requirementsLoading={requirementsLoading}
              handleEditUserInfoStatus={handleEditUserInfoStatus}
            />
          </TabPane>
        )}
        {hasAccess(MENU_USER_USERMANAGEMENT_WRITE, USERMANAGEMENT_USER_PERMISSIONS) && (
          <TabPane tab="Назначение привилегий" key="2">
            <AdministrationPermissions
              user={user}
              users={users}
              permissions={permissions}
              permissionsLoading={permissionsLoading}
              selectedUser={user}
              handleAssignPermissionsToUser={handleAssignPermissionsToUser}
              selectable={false}
            />
          </TabPane>
        )}
        {hasAccess(MENU_USER_USERMANAGEMENT_WRITE, USERMANAGEMENT_USER_PERMISSIONS) && (
          <TabPane tab="Блокировка привилегий" key="3">
            <AdministrationBlockPermissions
              users={users}
              permissions={permissions}
              permissionsLoading={permissionsLoading}
              selectedUser={user}
              handleBlockPermissionsToUser={handleBlockPermissionsToUser}
              selectable={false}
            />
          </TabPane>
        )}
      </Tabs>
    </>
  );

  return <Spin spinning={!userLoaded}>{userLoaded && renderUserTabs()}</Spin>;
}
